/**
 * @Author: 派同学
 * @Description: How
 */
import ikun from '@/assets/images/man.png'
import { v4 as uuidv4 } from 'uuid'
import { gangweiTemplateArr } from './gangweiTemplate.js'
const defaultData2 = gangweiTemplateArr[9];

export const defaultData = {
  basicInfo: {
    title: '基础信息',
    cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
    edit: false,
    isAppear: true,
    avatar: ikun,
    basicInfos: [
      {
        id: uuidv4(),
        basicKey: '姓名',
        basicVal: '你的名字',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '求职意向',
        basicVal: 'xxxx岗位',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '期望月薪',
        basicVal: '10k-20k',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '性别',
        basicVal: '男',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '工作年限',
        basicVal: '1 - 3年',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '电话',
        basicVal: '12312344321',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '邮箱',
        basicVal: 'lover@163.com',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      }
    ]
  },
  otherInfos: [
    {
      id: uuidv4(),
      sort: 1,
      title: '教育经历',
      edit: false,
      isAppear: true,
      fromDate: '2019/09/01',
      toDate: '2023/07/01',
      toNow: false,
      isDisable: false,
      subject: 'XXX大学',
      major: 'XXXX专业',
      content: '**基础会计学、货币银行学、统计学、经济法概论、财务会计学、管理学原理、组织行为学、市场营销学、国际贸易理论、国际贸易实务、人力资源开发与管理、财务管理学、企业经营战略概论、质量管理学、西方经济学等等**',
      children: []
    },
    {
      id: uuidv4(),
      sort: 3,
      title: '工作经历',
      edit: false,
      isAppear: true,
      fromDate: '2020/10/11',
      toDate: '2021/01/23',
      toNow: false,
      isDisable: false,
      subject: '公司甲',
      major: '行政专员',
      content: `
        \n● 负责中心简单财务管理，资产管控；
        \n● 负责公司总部的来访客户接待工作，负责引导和介绍公司的分布情况；
        \n● 负责中心的行政事务，公司班车管理、负责建立员工归属感及前台管理；
        \n● 负责招聘工作，确保人才梯队发展和人才储备及培养。
        `,
      children: [
        {
          id: uuidv4(),
          sort: 1,
          edit: false,
          isAppear: true,
          isLeaf: true,
          fromDate: '2020/10/11',
          toDate: '2021/01/23',
          toNow: false,
          isDisable: false,
          subject: '公司乙',
          major: '行政专员',
          content: `
          \n● 拥负责本部的行政人事管理和日常事务，协助总监搞好各部门之间的综合协调，落实公司规章制度，沟通内外联系，保证上情下达和下情上报，负责对会议文件决定的事项进行催办、查办和落实，负责全公司组织系统研讨和修订。
          \n● 编制公司人事管理制度，规避各项人事风险。 
          `
        }
      ]
    },
    {
      id: uuidv4(),
      sort: 4,
      title: '荣誉证书',
      edit: false,
      isAppear: true,
      fromDate: '',
      toDate: '',
      toNow: false,
      isDisable: true,
      subject: '',
      major: '',
      content: `
        \n1、英语四级，听说读写能力良好，能流利的用英语进行日常交流，能快速浏览英文文档和书籍；
        \n2、通过全国计算机二级考试，熟练运用office等常用的办公软件。
      `,
      children: []
    },
    {
      id: uuidv4(),
      sort: 5,
      title: '个人评价',
      edit: false,
      isAppear: true,
      fromDate: '',
      toDate: '',
      toNow: false,
      isDisable: true,
      subject: '',
      major: '',
      content: `工作积极认真，细心负责，熟练运用办公自动化软件，善于在工作中提出问题、发现问题、解决问题，有较强的分析能力；勤奋好学，踏实肯干，动手能力强，认真负责，有很强的社会责任感；坚毅不拔，吃苦耐劳，喜欢迎接新挑战。`,
      children: []
    }
  ]
};

export const commonTemplateArr = [
  {
    id: 1,
    styleType: 'normal1Style',
    tag: '基础模版',
    title: "简约专业简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_9DtqZU3W17443783542025961.png",
    showTags: ['热门', '经典', '简约'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 2,
    styleType: 'normal2Style',
    title: "经典双栏专业简历模板",
    tag: '基础模版',
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_FhLd5gFw17443784094494045.png",
    showTags: ['经典', '双栏'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 3,
    tag: '基础模版',
    styleType: 'normal3Style',
    title: "经典上下布局简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_WPtoefRC17443784460455156.png",
    showTags: ['热门', '简约', '上下布局'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 4,
    tag: '基础模版',
    styleType: 'normal4Style',
    title: "简约专业简历模板2",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_UTKv2jN317444485347455627.png",
    showTags: ['经典', '简约'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 5,
    tag: '基础模版',
    styleType: 'normal5Style',
    title: "简约专业简历模板3",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_Jya67Rda17444573457566119.png",
    showTags: ['经典', '简约'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 6,
    tag: '基础模版',
    styleType: 'normal6Style',
    title: "经典表格式简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_5ezXlwxV17448158584802486.png",
    showTags: ['经典', '表格'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: true,
  },
  {
    id: 7,
    tag: '基础模版',
    styleType: 'normal7Style',
    title: "现代卡片式简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NKZTAtBc17552634954263592.jpeg",
    showTags: ['热门', '现代', '卡片'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 8,
    tag: '基础模版',
    styleType: 'normal8Style',
    title: "现代时间线简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_NYwI78fa17552631434806492.jpeg",
    showTags: ['热门', '时间线', '卡片'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 9,
    tag: '基础模版',
    styleType: 'normal9Style',
    title: "现代圆角非卡片简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_SvGBRvQb1755263155483416.jpeg",
    showTags: ['热门', '圆角', '简约'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 10,
    tag: '基础模版',
    styleType: 'normal10Style',
    title: "现代渐变风格简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_d1nUBNFr17621854624972895.jpeg",
    showTags: ['最新', '渐变', '现代'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 11,
    tag: '基础模版',
    styleType: 'normal11Style',
    title: "简约横栏风格简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_51SpfSRN17789951887457604.jpeg",
    showTags: ['最新', '简约', '热门'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  },
  {
    id: 12,
    tag: '基础模版',
    styleType: 'normal12Style',
    title: "简洁商务中文简历模板",
    newcover: "https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_63AGUux717789952136413338.jpeg",
    showTags: ['最新', '商务', '热门', '简约'], // 模版特点
    category: 'normal',// 基础类型的模版
    disableCusMargin: false,
  }
]


export const getDeafutTemplate = () => {
  const returnDefault = Object.assign({}, defaultData, commonTemplateArr[0]);
  console.log("returnDefault==>", returnDefault);
  return returnDefault;
};

export const createResumeV2Data = {
  basicInfo: {
    title: '基础信息',
    cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_PXuKBka117088015157217095.png',
    edit: false,
    isAppear: true,
    avatar: ikun,
    basicInfos: [
      {
        id: uuidv4(),
        basicKey: '姓名',
        basicVal: '你的名字',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '求职意向',
        basicVal: 'XXXXX岗位',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '性别',
        basicVal: '男',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '邮箱',
        basicVal: 'lover@163.com',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      },
      {
        id: uuidv4(),
        basicKey: '期望薪资',
        basicVal: '3000',
        placeholderKey: '属性',
        placeholderVal: '属性值'
      }
    ]
  },
  otherInfos: [
    {
      id: uuidv4(),
      sort: 1,
      title: '教育经历',
      edit: false,
      isAppear: true,
      fromDate: '2019/09/01',
      toDate: '2023/07/01',
      toNow: false,
      isDisable: false,
      subject: 'XXX大学',
      major: 'XXXX专业',
      content: '这里写你的教育经历',
      children: []
    },
    {
      id: uuidv4(),
      sort: 3,
      title: '工作经历',
      edit: false,
      isAppear: true,
      fromDate: '2020/10/11',
      toDate: '2021/01/23',
      toNow: false,
      isDisable: false,
      subject: '公司甲',
      major: 'XXX岗位',
      content: '这里写你的工作经历1',
      children: [
        {
          id: uuidv4(),
          sort: 1,
          edit: false,
          isAppear: true,
          isLeaf: true,
          fromDate: '2020/10/11',
          toDate: '2021/01/23',
          toNow: false,
          isDisable: false,
          subject: '公司乙',
          major: 'XXX岗位',
          content: '这里写你的工作经历2'
        }
      ]
    },
    {
      id: uuidv4(),
      sort: 5,
      title: '个人评价',
      edit: false,
      isAppear: true,
      fromDate: '',
      toDate: '',
      toNow: false,
      isDisable: true,
      subject: '',
      major: '',
      content: '这里写你的个人评价',
      children: []
    }
  ]
};

export const getCreateV2Template = () => {
  let randomCommonTemplate = commonTemplateArr[Math.floor(Math.random() * commonTemplateArr.length)];
  const returnDefault = Object.assign({}, createResumeV2Data, randomCommonTemplate);
  console.log("getCreateV2Template==>", returnDefault);
  return returnDefault;
};